import { usePaperMetaQuery } from "@/features/citations/api/queries";
import { getExternalUrlFromId, getOriginalPaperUrl } from "@/features/citations/utils/originalUrl";
import { ExternalLink } from "lucide-react";

interface OriginalSourceLinkProps {
  docId?: string | null;
  /** A known http(s) URL of the source; it is used as is. */
  url?: string | null;
  /** Paper metadata exists only for papers, so other sources skip that lookup. */
  isPaper?: boolean;
}

/** A link to the publisher page of a cited document, when one is known. */
export const OriginalSourceLink = ({ docId, url, isPaper = true }: OriginalSourceLinkProps) => {
  const id = docId ?? "";
  const { data: meta } = usePaperMetaQuery(!url && isPaper && id ? id : undefined);
  const href =
    url ||
    (meta && (meta.public_url || getOriginalPaperUrl(meta, id))) ||
    (id ? getExternalUrlFromId(id) : null);
  if (!href) return null;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-1 whitespace-nowrap font-medium text-zinc-700 underline decoration-zinc-300 underline-offset-2 hover:decoration-zinc-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-zinc-900"
    >
      Open original source
      <ExternalLink className="h-3 w-3" aria-hidden />
    </a>
  );
};
